import Card from "components/card";

const Widget = ({ icon, title, subtitle }) => {
  return (
    <Card extra="!flex-row items-center rounded-[20px] min-w-0 overflow-hidden p-3 sm:p-4 md:pl-5 flex-shrink-0">
      <div className="ml-0 sm:ml-2 flex h-12 sm:h-14 w-auto flex-shrink-0 flex-row items-center">
        <div className="rounded-full bg-lightPrimary p-2 dark:bg-navy-700">
          <span className="flex items-center text-brand-500 dark:text-white">
            {icon}
          </span>
        </div>
      </div>

      <div className="h-50 ml-3 sm:ml-4 flex min-w-0 flex-1 flex-col justify-center">
        <p className="font-dm text-xs sm:text-sm font-medium text-gray-600 truncate">{title}</p>
        <h4 className="text-base sm:text-lg md:text-xl font-bold text-navy-700 dark:text-white truncate">
          {subtitle}
        </h4>
      </div>
    </Card>
  );
};

export default Widget;
